import { useTranslation } from 'react-i18next';

import { useAppDispatch } from 'Libs/redux/store';

import { actions } from 'Pages/Courses/redux/slice';
import { TabsEnum } from 'Pages/Courses/types';
import { useModuleSelector } from 'Pages/Courses/redux';

export const tabNames = {
  [TabsEnum.CONTENT]: 'courses:edition_bar.content_tab',
  [TabsEnum.AUDIENCE]: 'courses:edition_bar.audience_tab',
};

const getCourseIdFromUrl = () => {
  const urlPathname = window.location.pathname;
  const courseId = urlPathname.split('/')[2];

  return Number(courseId);
};

export const useAICourseEditionTabs = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  // switching to number is needed to ensure type compatibility with the existing useCourseEditionTabs
  const currentTab = useModuleSelector((state) => {
    switch (state.aiEdition.currentTab) {
      case TabsEnum.CONTENT:
        return 0;
      case TabsEnum.AUDIENCE:
        return 1;
    }
  });
  const setCurrentTab = (tab: number) => {
    if (tab === 0) {
      dispatch(actions.setAICurrentTab(TabsEnum.CONTENT));
    } else if (tab === 1) {
      dispatch(actions.setAICurrentTab(TabsEnum.AUDIENCE));
    }
  };

  const tabList = [t(tabNames[TabsEnum.CONTENT]).toUpperCase(), t(tabNames[TabsEnum.AUDIENCE]).toUpperCase()];

  const courseId = getCourseIdFromUrl();

  return {
    currentTabIndex: currentTab,
    goToTab: setCurrentTab,
    tabs: tabList,
    idParam: courseId,
    currentTab: undefined,
  };
};
